import React, { useEffect, useState } from 'react'
import moment from 'moment'
import _ from 'lodash'
import numeral from 'numeral'
import {
 Drawer, Dropdown, Menu, DatePicker, Button,
} from 'antd'
import {
 P, Div, H3, Icon, H4, SmallText, Input,
} from 'konsys-ui'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'
import {
 MapPinned, Ellipsis, Fuel, CalendarX,
 Truck,
 Droplets,
} from 'lucide-react'
import { FUEL_ORDER_LIST, SHIPPING_ORDER } from '../../../constants/graphql/query'
import { MYINFO } from '../../../constants/graph/query'
import { theme } from '../../../styles/_variables'
import { CardStyled } from '../styled'
import { TagMobile, Loading } from '../../../components/common'
import { mobileTextSelector, mobileColorSelector } from './config'
import { fuelTypeList } from '../detail/component-renderer'
import { DropdownSelector, QrcodeModal } from '../../../components/filling-order-components'
import ROLE from '../../../constants/role'

const { color } = theme


const Card = ({ data, isGasstation }) => {
  const [scanModal, setScanModal] = useState(false)

  const menu = (
    <Menu onClick={(e) => {
      if (e?.key === 'scan') {
        setScanModal(true)
      }
    }}>
      <Menu.Item key="scan">
        Scan QR code
      </Menu.Item>
    </Menu>
  )
  return (
    <CardStyled display='flex' flexDirection='column' padding='8px 16px' margin='8px 0' width='100%'>
      <QrcodeModal id={data?.id} qrCodeModal={scanModal} setQrCodeModal={setScanModal} info={data}/>
      <Div justifyContent='space-between' width='100%' alignItems='center' display='flex' margin='0 0 16px 0'>
        <Div alignItems='center' display='flex' width='calc(100% - 100px)'>
          <MapPinned className='size-6 mr-2' color={theme.color.primaryColor} />
          <Div alignItems='flex-start' display='flex' flexDirection='column' justifyContent='flex-start'>
            <SmallText>{data?.Gasstation?.name}</SmallText>
            <SmallText>{data?.shippingVolume}/{data?.shippingNumber}</SmallText>
          </Div>
        </Div>
        <TagMobile text={mobileTextSelector(data.status)} color={mobileColorSelector(data.status)}/>
        {
          !isGasstation && <Dropdown overlay={menu} trigger={['click']} on>
            <Ellipsis className='size-4 mx-2' color={theme.color.primaryColor} />
          </Dropdown>
        }
      </Div>
      <Div justifyContent='space-between' width='100%' alignItems='flex-end' display='flex' margin='0 0 8px 0'>
        <Div>
          <Div width='100%' alignItems='center' display='flex' margin='0 0 8px 0'>
            <Fuel className='size-6 mr-2' color={theme.color.coolGrey} />
            <SmallText color={theme.color.coolGrey}>{_.find(fuelTypeList, o => o.value === data?.fuelType)?.text || '-'}</SmallText>
          </Div>
          <Div width='100%' alignItems='center' display='flex'>
            <CalendarX className='size-6 mr-2' color={theme.color.coolGrey} />
            <SmallText color={theme.color.coolGrey}>{data?.expiredDate ? moment(data?.expiredDate).format('DD / MM / YYYY') : '-'}</SmallText>
          </Div>
        </Div>
        <Div>
          <Div width='100%' alignItems='center' display='flex' margin='0 0 8px 0' justifyContent='flex-end'>
            <Truck className='size-6 mr-2' color={theme.color.coolGrey} />
            <SmallText color={theme.color.coolGrey}>{data?.ShippingOrder?.Truck?.plateNumber}</SmallText>
          </Div>
          <Div justifyContent='flex-end' alignItems='center' display='flex'>
            <Droplets className='size-8 mr-2' color={theme.color.primaryColor} />
            <H4 bold color={theme.color.primaryColor}>{data?.totalAmount} ลิตร</H4>
          </Div>
        </Div>
      </Div>
    </CardStyled>
  )
}

export const MobileFuelList = ({ props }) => {
  const [doGetFuelOrders, {
    data, loading, fetchMore,
  }] = useLazyQuery(FUEL_ORDER_LIST)

  const {
    data: myInfo, loading: myInfoLoading,
  } = useQuery(MYINFO)

  const [search, setSearch] = useState(false)

  const [searchText, setSearchText] = useState()
  const [key, setKey] = useState()
  const [shippingNumber, setShippingNumber] = useState()
  const [shippingVolume, setShippingVolume] = useState()
  const [expiredDate, setExpiredDate] = useState()
  const [name, setName] = useState()
  const [company, setCompany] = useState()
  const [status, setStatus] = useState()

  useEffect(() => {
    doGetFuelOrders({
      variables: {
        limit: 10,
        offset: 0,
        orderBy: 'DESC',
        orderField: 'updatedAt',
        id: parseInt(props?.match?.params?.id, 10) || undefined,
      },
    })
  }, [])

  const isGasstation = ROLE.FUEL_FILLER.id === myInfo?.myInfo?.Roles[0].id

  return (
    <Div display='flex' flexDirection='column'>
      <Drawer
        title='ค้นหา'
        placement='top'
        closable={false}
        onClose={() => setSearch(false)}
        visible={search}
        height={400}
      >
        <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
          <P margin='0 8px 0 0'>เล่มที่</P>
          <Input value={shippingVolume} onChange={e => setShippingVolume(e.target.value)} />
        </Div>
        <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
          <P>เลขที่</P>
          <Input value={shippingNumber} onChange={e => setShippingNumber(e.target.value)} />
        </Div>
        <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
          <P>วันที่ครบกำหนด</P>
          <DatePicker format='DD/MM/YY' value={expiredDate} onChange={e => (_.isNull(e) ? setExpiredDate(undefined) : setExpiredDate(moment(e)))}/>
        </Div>
        {
          !isGasstation
          && <React.Fragment>
            <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
              <P>ชื่อสถานี</P>
              <Input value={name} onChange={e => setName(e.target.value)} />
            </Div>
            <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
              <P>บริษัท</P>
              <DropdownSelector
                key='filter'
                data={[{
                  value: 'ALL',
                  text: 'ทั้งหมด',
                }, {
                  value: 'SHELL',
                  text: 'SHELL',
                }, {
                  value: 'BANGCHAK',
                  text: 'BANGCHAK',
                }, {
                  value: 'CALTEX',
                  text: 'CALTEX',
                }, {
                  value: 'ESSO',
                  text: 'ESSO',
                }, {
                  value: 'PTT',
                  text: 'PTT',
                }, {
                  value: 'PT',
                  text: 'PT',
                }, {
                  value: 'OTHER',
                  text: 'OTHER',
                }]}
                handleChange={e => setCompany(e)}
                filter={true}
                statusAttr='ทั้งหมด'
                value={company}
                typeNameTh={true}
              />
            </Div>
          </React.Fragment>
        }
        {/* <Div display='flex' margin='4px 0' alignItems='center' justifyContent='space-between'>
          <P>สถานะ</P>
          <StatusSelector key='filter' statusAttr='ทั้งหมด' handleChange={e => setStatus(e)} value={status} filter={true} mobile={true} />
        </Div> */}
        <div
          style={{
            textAlign: 'right',
            alignSelf: 'flex-end',
            marginTop: 8,
          }}
        >
          <Button
            onClick={() => {
              doGetFuelOrders({
                variables: {
                  limit: 10,
                  offset: 0,
                  orderBy: 'DESC',
                  orderField: 'updatedAt',
                },
              })
              setShippingNumber()
              setShippingVolume()
              setExpiredDate()
              setName()
              setCompany()
              setSearchText()
              setStatus()
              setKey()
              setSearch(false)
            }}
            style={{ marginRight: 8 }}
          >
            ล้างค่า
          </Button>
          <Button
            onClick={() => {
              doGetFuelOrders({
                variables: {
                  limit: 10,
                  offset: 0,
                  orderBy: 'DESC',
                  orderField: 'updatedAt',
                  shippingNumber,
                  shippingVolume,
                  expiredDate,
                  name,
                  company,
                  status,
                },
              })
              setSearch(false)
              }
            }
            type="primary"
          >
            ค้นหา
          </Button>
        </div>
      </Drawer>
      <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        <H3 bold color={color.primaryColor} margin='32px 0'>ใบเบิกน้ำมัน</H3>
        <Div display='flex' flexDirection='row' alignItems='center'>
          <Icon icon='far fa-search' fontSize='25px' color={theme.color.primaryColor} onClick={() => setSearch(true)}/>
        </Div>
      </Div>
      <Div
        margin='-8px 0'
        height='calc(100vh - 266px)'
        style={{ overflowY: 'auto' }}
        onScroll={(e) => {
          if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight && data.FuelOrderList.lists.length < data.FuelOrderList.totalFilter) {
            fetchMore({
              variables: {
                offset: data.FuelOrderList.lists.length,
                limit: 10,
              },
              updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev
                const newData = {
                  ...prev,
                  FuelOrderList: {
                    ...prev.FuelOrderList,
                    lists: [
                      ...prev.FuelOrderList.lists,
                      ...fetchMoreResult.FuelOrderList.lists,
                    ],
                  },
                }
                return { ...newData }
              },
            })
          }
        }}
      >
      {
          _.isEmpty(data?.FuelOrderList?.lists)
          ? <P bold color={theme.color.purplishGrey}>ไม่พบรายการที่ค้นหา</P>
          : data?.FuelOrderList?.lists.map(order => (
            <Card key={order.id} data={order} isGasstation={isGasstation}/>
          ))
        }
      </Div>
      {loading && <Loading />}
    </Div>
  )
}

export default MobileFuelList
